// 管理后台专用 HTTP 实例：与 test-vue-01 全局 axios 解耦，
// 自带 JWT 注入与统一响应包装，不污染其他模块。
import axios from 'axios'

const TOKEN_KEY = 'admin_jwt'
const ADMIN_KEY = 'admin_profile'

export function getToken () {
  return localStorage.getItem(TOKEN_KEY) || ''
}

export function setToken (token) {
  if (token) localStorage.setItem(TOKEN_KEY, token)
}

export function clearAuth () {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(ADMIN_KEY)
}

export function getProfile () {
  const raw = localStorage.getItem(ADMIN_KEY)
  return raw ? JSON.parse(raw) : null
}

export function setProfile (profile) {
  if (profile) localStorage.setItem(ADMIN_KEY, JSON.stringify(profile))
}

const service = axios.create({
  baseURL: '/',
  timeout: 15000
})

service.interceptors.request.use(
  config => {
    const token = getToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => Promise.reject(error)
)

service.interceptors.response.use(
  response => {
    const body = response.data
    // 后端 ApiResp 约定：成功 code="1111"（字符串），失败 code="0000"，
    // 鉴权类错误另有 "0001".."0011"。字段为 code/data/msg。
    if (body && typeof body.code !== 'undefined') {
      if (body.code === '1111') {
        return body.data
      }
      // 业务失败：抛出 msg
      const err = new Error(body.msg || '请求失败')
      err.code = body.code
      throw err
    }
    return body
  },
  error => {
    let message = '网络错误'
    if (error.response) {
      const status = error.response.status
      if (status === 401) {
        clearAuth()
        message = '登录已失效，请重新登录'
      } else if (status === 403) {
        message = '无权限访问'
      } else if (error.response.data && error.response.data.message) {
        message = error.response.data.message
      } else {
        message = `请求失败 (${status})`
      }
    } else if (error.code !== undefined) {
      message = error.message
    }
    error.uiMessage = message
    return Promise.reject(error)
  }
)

export default service
